import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateAccountApiRequest } from "../../services";
import { TUpdateAccount } from "../../types";
import { updateTypeTransactionApi } from "../../services/type-transaction/update.type.transaction.api";

export const useUpdateTypeTransactionApi = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (infoUpdate: any) => updateTypeTransactionApi(infoUpdate),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["type-transaction"],
      });
    },
  });
};
